export const env = {
    BASE_URL: 'https://fr-instalacoes.com.br/wp-json/api'
}